import {MatTooltipDefaultOptions} from "@angular/material/tooltip";

/** Custom options the configure the tooltip's default show/hide delays. */
export const CustomTooltipDefaults:
  MatTooltipDefaultOptions = {
  showDelay: 750,
  hideDelay: 250,
  touchendHideDelay: 1000,
};
